import { Component, Input, Renderer2 } from '@angular/core';
import { BalanceService } from 'src/app/services/balance.service';
import { HttpService } from 'src/app/services/http.service';

declare var P;

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss'],
})
export class CheckoutComponent {
  @Input() orderId: string;
  @Input() set amount(value: number) {
    if (value) {
      console.log('amount :>> ', value);
      this._vAmount = value;
      this._getSession();
    }
  }
  private _vAmount = 0;

  constructor(
    private _vRenderer: Renderer2,
    private _vHttpSv: HttpService,
    private _vCurrencySv: BalanceService
  ) {}

  private async _getSession() {
    const res = await this._vHttpSv.itemIndex(
      'placetopay',
      '',
      {
        amount: this._vAmount,
        currency: this._vCurrencySv.currency.symbol,
        orderId: this.orderId,
        returnUrl: '/pending-orders',
        userAgent: navigator.userAgent,
      },
      'generateHash'
    );
    this._initCheckout(res.data);
  }

  private _initCheckout(session: string) {
    const script = document.createElement('script');
    script.src = 'https://checkout.placetopay.com/lightbox.min.js';

    script.onload = () => {
      this.setHandlerPlaceToPay(session);
    };

    const form = document.getElementById('checkout');
    this._vRenderer.appendChild(form, script);
  }

  setHandlerPlaceToPay(session: string) {
    P.on('response', (response) => {
      console.log('response :>> ', response);
    });
    const processCheckout = `https://checkout.placetopay.com/spa/session/${session}`;
    P.init(processCheckout);
  }
}
